import api from './api';

const sortByName = (items = []) =>
  [...items].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', 'es', { sensitivity: 'base' })
  );

const catalogService = {
  // Obtener catálogo de productos con precios según usuario
  async getProducts(params = {}) {
    try {
      const response = await api.get('/catalog/products', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener catálogo:', error);
      throw error;
    }
  },

  // Obtener detalle de producto con precio según usuario
  async getProductById(id) {
    try {
      const response = await api.get(`/catalog/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener producto:', error);
      throw error;
    }
  },

  // Obtener categorías disponibles
  async getCategories() {
    try {
      const response = await api.get('/catalog/categories');
      return {
        ...response.data,
        data: sortByName(response.data.data)
      };
    } catch (error) {
      console.error('Error al obtener categorías:', error);
      throw error;
    }
  },

  // Obtener marcas disponibles
  async getBrands() {
    try {
      const response = await api.get('/catalog/brands');
      return response.data;
    } catch (error) {
      console.error('Error al obtener marcas:', error);
      throw error;
    }
  }
};

export default catalogService;

